import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './style/App.css';
import { FaCopy } from 'react-icons/fa';

export default function AdminDashboard() {
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);

  // --- SEARCH & USER MANAGEMENT ---
  const [searchResult, setSearchResult] = useState(null);
  const [searchError, setSearchError] = useState('');
  const [showAddUserForm, setShowAddUserForm] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [listError, setListError] = useState('');
  const [showTransferHouseForm, setShowTransferHouseForm] = useState(false);
  const [transferUserId, setTransferUserId] = useState('');
  const [transferError, setTransferError] = useState('');
  const [userName, setUserName] = useState('');
  const [userRole, setUserRole] = useState('');
  const [userFilter, setUserFilter] = useState('');

  // --- CREATE USER STATES ---
  const [newFirstName, setNewFirstName] = useState('');
  const [newLastName, setNewLastName] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [newPhone, setNewPhone] = useState('');
  const [newRole, setNewRole] = useState('USER');
  const [creationError, setCreationError] = useState('');

  // --- COMPANY (multi-tenant) STATES ---
  const [companyName, setCompanyName] = useState('');
  const [companiesList, setCompaniesList] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState('');
  const [useNewCompany, setUseNewCompany] = useState(false);
  const [newCompanyNameInput, setNewCompanyNameInput] = useState('');
  const [showAddCompanyForm, setShowAddCompanyForm] = useState(false);
  const [createCompanyName, setCreateCompanyName] = useState('');
  const [createCompanyError, setCreateCompanyError] = useState('');
  const [selectedManageCompanyId, setSelectedManageCompanyId] = useState('');
  const [showModifyCompanyForm, setShowModifyCompanyForm] = useState(false);
  const [modifyCompanyNameInput, setModifyCompanyNameInput] = useState('');
  const [modifyCompanyError, setModifyCompanyError] = useState('');
  const [deleteCompanyError, setDeleteCompanyError] = useState('');

  // For delete user
  const [deleteError, setDeleteError] = useState('');

  // For update user
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [updateUserId, setUpdateUserId] = useState(null);
  const [updateFirstName, setUpdateFirstName] = useState('');
  const [updateLastName, setUpdateLastName] = useState('');
  const [updateEmail, setUpdateEmail] = useState('');
  const [updatePhone, setUpdatePhone] = useState('');
  const [updateError, setUpdateError] = useState('');

  // --- HOUSE MANAGEMENT ---
  const [addressOptions, setAddressOptions] = useState([]);
  const [selectedHouse, setSelectedHouse] = useState('');
  const [showAddHouseForm, setShowAddHouseForm] = useState(false);
  const [showModifyHouseForm, setShowModifyHouseForm] = useState(false);
  const [newStreet, setNewStreet] = useState('');
  const [newPostalCode, setNewPostalCode] = useState('');
  const [newCity, setNewCity] = useState('');
  const [newCountry, setNewCountry] = useState('');
  const [newGateway, setNewGateway] = useState('');
  const [newGasType, setNewGasType] = useState('Natural');
  const [addHouseError, setAddHouseError] = useState('');
  const [modifyStreetInput, setModifyStreetInput] = useState('');
  const [modifyPostalInput, setModifyPostalInput] = useState('');
  const [modifyCityInput, setModifyCityInput] = useState('');
  const [modifyCountryInput, setModifyCountryInput] = useState('');
  const [modifyGatewayInput, setModifyGatewayInput] = useState('');
  const [modifyGasTypeInput, setModifyGasTypeInput] = useState('Natural');
  const [modifyHouseError, setModifyHouseError] = useState('');
  const [deleteHouseError, setDeleteHouseError] = useState('');

  // --- ROOM MANAGEMENT ---
  const [roomOptions, setRoomOptions] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState('');
  const [showAddRoomForm, setShowAddRoomForm] = useState(false);
  const [showModifyRoomForm, setShowModifyRoomForm] = useState(false);
  const [newRoomName, setNewRoomName] = useState('');
  const [addRoomError, setAddRoomError] = useState('');
  const [modifyRoomNameInput, setModifyRoomNameInput] = useState('');
  const [modifyRoomError, setModifyRoomError] = useState('');
  const [deleteRoomError, setDeleteRoomError] = useState('');

  // --- SENSOR MANAGEMENT ---
  const [sensorData, setSensorData] = useState([]);
  const [sensorDataError, setSensorDataError] = useState('');
  const [selectedSensorSerial, setSelectedSensorSerial] = useState('');
  const [showAddSensorForm, setShowAddSensorForm] = useState(false);
  const [showModifySensorForm, setShowModifySensorForm] = useState(false);
  const [sensorSerialNumber, setSensorSerialNumber] = useState('');
  const [deviceTypeInput, setdeviceTypeInput] = useState('');
  const [addSensorError, setAddSensorError] = useState('');
  const [modifySensorSerialNumberInput, setModifySensorSerialNumberInput] = useState('');
  const [modifySensorError, setModifySensorError] = useState('');
  const [deleteSensorError, setDeleteSensorError] = useState('');
  const [now, setNow] = useState(Date.now());

  const navigate = useNavigate();

  const handleCopyEmail = (text) => {
    navigator.clipboard.writeText(text);
  };

  const fetchDashboardCount = async () => {
    try {
      setError('');
      const res = await fetch('/api/admin/dashboard', { credentials: 'include' });
      if (!res.ok) throw new Error('Access denied or error');
      const data = await res.json();
      setMessage(data.message);
    } catch (err) {
      setError(err.message);
    }
  };

  const filteredUsers = usersList.filter(u => {
    const q = userFilter.trim().toLowerCase();
    if (!q) return true;
    return u.first_name.toLowerCase().includes(q) ||
    u.last_name.toLowerCase().includes(q) ||
    u.email.toLowerCase().includes(q) ||
    u.phone.toLowerCase().includes(q);
  });

  const fetchIdentity = async () => {
    try {
      const res = await fetch('/api/verify', { credentials: 'include' });
      if (!res.ok) throw new Error('Not authenticated');
      const data = await res.json();
      setUserName(data.first_name);
      setUserRole(data.role);
      setCompanyName(data.company_name || '');
    } catch (err) {
      console.error('Could not fetch identity:', err);
    }
  };

  // SUPERADMIN only; silently ignored (403) for ADMIN
  const fetchCompanies = async () => {
    try {
      const res = await fetch('/api/superadmin/companies', { credentials: 'include' });
      if (!res.ok) return;
      const data = await res.json();
      setCompaniesList(data.companies || []);
    } catch (err) {
      console.error('Could not fetch companies:', err);
    }
  };

  const fetchUsers = async () => {
    try {
      setListError('');
      const res = await fetch('/api/admin/allusers', { credentials: 'include' });
      if (!res.ok) throw new Error('Failed to load users');
      const data = await res.json();
      setUsersList(data.users);
    } catch (err) {
      setListError(err.message);
    }
  };

  useEffect(() => {
    fetchUsers();
    fetchIdentity();
    fetchDashboardCount();
    fetchCompanies();
  }, []);

  useEffect(() => {
    if (!selectedRoom || showAddSensorForm || showModifySensorForm || showAddRoomForm || showModifyRoomForm || showAddHouseForm || showModifyHouseForm) {
      return;
    }

    const interval = setInterval(() => {
      handleFetchSensors(selectedRoom);
    }, 10000);

    return () => clearInterval(interval);
  }, [selectedRoom, showAddSensorForm, showModifySensorForm, showAddRoomForm, showModifyRoomForm, showAddHouseForm, showModifyHouseForm]);

  if (error) return <p>{error}</p>;

  // LOGOUT
  const handleLogout = async () => {
    await fetch('/api/logout', { method: 'POST', credentials: 'include' });
    navigate('/');
  };

  function normalizeInput(phoneOrEmail) {
    if (phoneOrEmail.includes('@')) return phoneOrEmail;
    return phoneOrEmail.replace(/[^\d\s+]/g, '').trim().replace(/\s{2,}/g, ' ').replace(/(\+?\d+)\s+(.*)/, '$1 $2').replace(/(\+?\d+\s\d+)\s+(.*)/, '$1$2');
  }

  // ADD / SEARCH / DELETE / MODIFY USER
  const handleCreateUser = async e => {
    e.preventDefault();
    setCreationError('');
    if (!newFirstName||!newLastName||!newEmail||!newPhone||!newStreet||!newPostalCode||!newCity||!newCountry||!newGateway) {
      return setCreationError('Please fill all fields');
    }
    if (newRole !== 'USER' && !(useNewCompany ? newCompanyNameInput : selectedCompanyId)) {
      return setCreationError('Please select or create a company for this admin');
    }

    const route = newRole === 'USER' ? '/admin/create-user' : '/superadmin/create-user';
    const normalized = normalizeInput(newPhone);
    try {
      const res = await fetch(`/api/${route}`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          firstName: newFirstName,
          lastName: newLastName,
          role: newRole,
          email: newEmail,
          phone: normalized,
          street: newStreet,
          postalCode: newPostalCode,
          city: newCity,
          country: newCountry,
          gateway: newGateway,
          gasType: newGasType,
          ...(newRole !== 'USER'
            ? (useNewCompany ? { newCompanyName: newCompanyNameInput } : { companyId: selectedCompanyId })
            : {})
        }),
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'Failed to create user');
      }
      setNewFirstName(''); setNewLastName(''); setNewEmail(''); setNewPhone('');
      setNewStreet(''); setNewPostalCode('');
      setNewCity(''); setNewCountry(''); setNewGateway(''); setShowAddUserForm(false);
      setSelectedCompanyId(''); setUseNewCompany(false); setNewCompanyNameInput('');
      fetchUsers();
      fetchCompanies();
    } catch (err) {
      setCreationError(err.message);
    }
  };

  const handleCreateCompany = async e => {
    e.preventDefault();
    setCreateCompanyError('');
    if (!createCompanyName) {
      return setCreateCompanyError('Please enter a company name');
    }
    try {
      const res = await fetch('/api/superadmin/create-company', {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ name: createCompanyName }),
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'Failed to create company');
      }
      setCreateCompanyName('');
      setShowAddCompanyForm(false);
      fetchCompanies();
    } catch (err) {
      setCreateCompanyError(err.message);
    }
  };

  const handleSelectCompany = (companyId) => {
    setSelectedManageCompanyId(companyId.toString());
    setShowModifyCompanyForm(false);
    setModifyCompanyError('');
    setDeleteCompanyError('');
  };

  const handleModifyCompany = async e => {
    e.preventDefault();
    setModifyCompanyError('');
    if (!selectedManageCompanyId || !modifyCompanyNameInput) {
      return setModifyCompanyError('Fill all fields');
    }
    try {
      const res = await fetch('/api/superadmin/modify-company', {
        method: 'PUT',
        credentials: 'include',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ companyId: selectedManageCompanyId, name: modifyCompanyNameInput }),
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'Failed to modify company');
      }
      setShowModifyCompanyForm(false);
      fetchCompanies();
    } catch (err) {
      setModifyCompanyError(err.message);
    }
  };

  const handleDeleteCompany = async () => {
    if (!selectedManageCompanyId) return setDeleteCompanyError('Select a company');
    if (!window.confirm('Delete this company?')) return;
    try {
      const res = await fetch('/api/superadmin/delete-company', {
        method: 'DELETE',
        credentials: 'include',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ companyId: selectedManageCompanyId }),
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'Failed to delete company');
      }
      setSelectedManageCompanyId('');
      setDeleteCompanyError('');
      fetchCompanies();
    } catch (err) {
      setDeleteCompanyError(err.message);
    }
  };

  const handleSearch = async (queryOrEvent) => {
    if (queryOrEvent?.preventDefault) {
      queryOrEvent.preventDefault();
    }

    const query = typeof queryOrEvent === 'string'
      ? queryOrEvent
      : searchResult?.email || '';

    setSearchError('');
    setSearchResult(null);
    setAddressOptions([]);
    setRoomOptions([]);
    setSelectedHouse('');
    setSelectedRoom('');

    if (!query) {
      return setSearchError('Please select a user from the table');
    }

    const normalizedQuery = normalizeInput(query);

    try {
      const res = await fetch(`/api/admin/search-user?query=${encodeURIComponent(normalizedQuery)}`, { credentials: 'include' });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'User not found');
      }
      const data = await res.json();
      setSearchResult(data);

      setDeleteError('');
      setShowUpdateForm(false);
      setUpdateUserId(data.user_id);
      setUpdateFirstName(data.first_name);
      setUpdateLastName(data.last_name);
      setUpdateEmail(data.email);
      setUpdatePhone(data.phone);
      setUpdateError('');

      const houseRes = await fetch(`/api/admin/houses?user_id=${data.user_id}`, { credentials: 'include' });
      if (!houseRes.ok) throw new Error('Failed to fetch houses');
      const houseData = await houseRes.json();
      setAddressOptions(houseData.houses || []);
    } catch (err) {
      setSearchError(err.message);
    }
  };

  const handleDeleteUser = async () => {
    if (!searchResult) return;
    if (!window.confirm('Delete this user and all linked data?')) return;
    try {
      const res = await fetch('/api/superadmin/delete-user', {
        method: 'DELETE',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: searchResult.email }),
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'Failed to delete user');
      }
      setDeleteError('');
      setSearchResult(null);
      fetchUsers();
    } catch (err) {
      setDeleteError(err.message);
    }
  };

  const handleUpdateUser = async e => {
    e.preventDefault();
    setUpdateError('');
    if (!updateUserId || !updateFirstName || !updateLastName || !updateEmail || !updatePhone) {
      return setUpdateError('Fill all fields');
    }

    const normalized = normalizeInput(updatePhone);
    try {
      const res = await fetch('/api/admin/update-user', {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId: updateUserId,
          firstName: updateFirstName,
          lastName: updateLastName,
          email: updateEmail,
          phone: normalized,
        }),
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'Failed to update user');
      }
      setUpdateError('');
      setShowUpdateForm(false);
      if (updateEmail !== searchResult?.email) {
        window.location.reload();
        return;
      }
      handleSearch(searchResult?.email);
    } catch (err) {
      setUpdateError(err.message);
    }
  };

  // FETCH ROOMS
  const handleFetchRooms = async houseId => {
    setSelectedHouse(houseId.toString());
    setShowTransferHouseForm(false);
    setTransferUserId('');
    setTransferError('');
    setDeleteHouseError('');
    setRoomOptions([]); setSelectedRoom(''); setShowModifyHouseForm(false); setShowAddHouseForm(false); setSelectedSensorSerial(''); 
    setSensorData([]);
    try {
      const res = await fetch(`/api/admin/rooms?house_id=${houseId}`, { credentials: 'include' });
      if (!res.ok) throw new Error('Failed to fetch rooms');
      const data = await res.json();
      setRoomOptions(data.rooms || []);
    } catch (err) {
      console.error(err);
    }
  };

  // FETCH SENSORS
  const handleFetchSensors = async roomId => {
    setSelectedRoom(roomId.toString());
    setShowTransferHouseForm(false);
    setTransferUserId('');
    setTransferError('');
    setSensorData([]); setSensorDataError(''); setShowModifyRoomForm(false); setShowAddRoomForm(false); setShowModifySensorForm(false); setSelectedSensorSerial(''); setShowAddSensorForm(false);
    try {
      const res = await fetch(`/api/room-sensors?room_id=${roomId}`, { credentials: 'include' });
      if (!res.ok) throw new Error('Failed to fetch sensors');
      const data = await res.json();
      setSensorData(data);
    } catch (err) {
      setSensorDataError(err.message);
    }
  };

  const isSensorActive = (timestamp) => {
    if (!timestamp) return false;
    const lastUpdate = new Date(timestamp).getTime();
    const hourInMs = 3 * 60 * 1000;
    return (Date.now() - lastUpdate) < hourInMs;
  };

  // ADD / MODIFY / DELETE HOUSE
  const handleAddHouse = async e => {
    e.preventDefault();
    setAddHouseError('');
    if (!newStreet || !newPostalCode || !newCity || !newCountry || !newGateway || !newGasType || !searchResult?.user_id) {
      return setAddHouseError('Fill all fields');
    }
    try {
      const res = await fetch('/api/admin/add-house', {
        method: 'POST',
        credentials: 'include',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          street: newStreet, postalCode: newPostalCode,
          city: newCity, country: newCountry, gateway: newGateway,
          gasType: newGasType, userId: searchResult.user_id
        }),
      });
      if (!res.ok) throw new Error('Failed to add house');
      setShowAddHouseForm(false);
      setNewStreet(''); setNewPostalCode(''); setNewCity(''); setNewCountry(''); setNewGateway(''); setNewGasType('');
      handleSearch(searchResult?.email);
    } catch (err) {
      setAddHouseError(err.message);
    }
  };

  const handleModifyHouse = async e => {
    e.preventDefault();
    setModifyHouseError('');
    if (!selectedHouse || !modifyStreetInput || !modifyPostalInput || !modifyCityInput || !modifyCountryInput || !modifyGatewayInput || !modifyGasTypeInput) {
      return setModifyHouseError('Fill all fields');
    }
    try {
      const res = await fetch('/api/admin/modify-house', {
        method:'PUT', credentials:'include',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          houseId: selectedHouse, street: modifyStreetInput,
          postalCode: modifyPostalInput, city: modifyCityInput,
          country: modifyCountryInput, gasType: modifyGasTypeInput, gateway: modifyGatewayInput
        }),
      });
      if (!res.ok) throw new Error('Failed to modify house');
      setShowModifyHouseForm(false);
      handleSearch(searchResult?.email);
    } catch (err) {
      setModifyHouseError(err.message);
    }
  };

  const handleDeleteHouse = async () => {
    if (!selectedHouse) return setDeleteHouseError('Select a house');
    if (!window.confirm('Delete this house?')) return;
    try {
      const res = await fetch('/api/superadmin/delete-house', {
        method:'DELETE', credentials:'include',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({ houseId: selectedHouse }),
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'Failed to delete house');
      }
      setSelectedHouse('');
      handleSearch(searchResult?.email);
    } catch (err) {
      setDeleteHouseError(err.message);
    }
  };

  // ADD / MODIFY / DELETE ROOM
  const handleAddRoom = async e => {
    e.preventDefault();
    setAddRoomError('');
    if (!selectedHouse||!newRoomName) {
      return setAddRoomError('Fill all fields');
    }
    try {
      const res = await fetch('/api/admin/add-room', {
        method:'POST', credentials:'include',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          houseId: selectedHouse,
          roomName: newRoomName
        }),
      });
      if (!res.ok) throw new Error('Failed to add room');
      setShowAddRoomForm(false);
      setNewRoomName('');
      handleFetchRooms(selectedHouse);
    } catch (err) {
      setAddRoomError(err.message);
    }
  };

  const handleModifyRoom = async e => {
    e.preventDefault();
    setModifyRoomError('');
    if (!selectedRoom||!modifyRoomNameInput) {
      return setModifyRoomError('Fill all fields');
    }
    try {
      const res = await fetch('/api/admin/modify-room', {
        method:'PUT', credentials:'include',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          roomId: selectedRoom,
          newRoomName: modifyRoomNameInput
        }),
      });
      if (!res.ok) throw new Error('Failed to modify room'); 
      setShowModifyRoomForm(false);
      handleFetchRooms(selectedHouse);
    } catch (err) {
      setModifyRoomError(err.message);
    }
  };

  const handleDeleteRoom = async () => {
    if (!selectedRoom) return setDeleteRoomError('Select a room');
    if (!window.confirm('Delete this room and its sensors?')) return;
    try {
      const res = await fetch('/api/admin/delete-room', {
        method:'DELETE', credentials:'include',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ roomId: selectedRoom }),
      });
      if (!res.ok) throw new Error('Failed to delete room');
      setSelectedRoom('');
      handleFetchRooms(selectedHouse);
    } catch (err) {
      setDeleteRoomError(err.message);
    }
  };

  // ADD / MODIFY / DELETE SENSOR
  const handleAddSensor = async e => {
    e.preventDefault();
    setAddSensorError('');
    if (!sensorSerialNumber||!deviceTypeInput||!selectedRoom||!searchResult?.user_id) {
      return setAddSensorError('Fill all fields');
    }
    try {
      const res = await fetch('/api/admin/add-sensor-identification', {
        method:'POST', credentials:'include',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          serialNumber: sensorSerialNumber,
          deviceType: deviceTypeInput,
          houseId: selectedHouse,
          roomId: selectedRoom,
          userId: searchResult.user_id
        }),
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'Failed to add sensor');
      }
      setShowAddSensorForm(false);
      setSensorSerialNumber(''); setdeviceTypeInput('');
      handleFetchSensors(selectedRoom);
    } catch (err) {
      setAddSensorError(err.message);
    }
  };
  
  const handleModifySensor = async e => {
    e.preventDefault();
    setModifySensorError('');
    try {
      const res = await fetch('/api/admin/modify-sensor', {
        method:'PUT', credentials:'include',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          serialNumber: selectedSensorSerial,
          newSerialNumber: modifySensorSerialNumberInput,
        }),
      });
      if (!res.ok) throw new Error('Failed to modify sensor');
      setShowModifySensorForm(false);
      setSelectedSensorSerial('');
      handleFetchSensors(selectedRoom);
    } catch (err) {
      setModifySensorError(err.message);
    }
  };

  const handleDeleteSensor = async () => {
    if (!selectedSensorSerial) return setDeleteSensorError('Select a sensor');
    if (!window.confirm(`Delete sensor ${selectedSensorSerial}?`)) return;
    try {
      const res = await fetch('/api/admin/delete-sensor', {
        method:'DELETE', credentials:'include',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ serialNumber: selectedSensorSerial }),
      });
      if (!res.ok) throw new Error('Failed to delete sensor');
      setSelectedSensorSerial('');
      handleFetchSensors(selectedRoom);
    } catch (err) {
      setDeleteSensorError(err.message);
    }
  };

  const handleTransferHouse = async e => {
    e.preventDefault();
    setTransferError('');
    if (!selectedHouse || !transferUserId) {
      return setTransferError('Please select a new owner');
    }
    try {
      const res = await fetch('/api/superadmin/transfer-house',
        {
          method: 'PUT',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            houseId: selectedHouse,
            newUserId: transferUserId,
          }),
        }
      );
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message || 'Transfer failed');
      }
      setShowTransferHouseForm(false);
      // refresh the current user view
      handleSearch(searchResult?.email);
    } catch (err) {
      setTransferError(err.message);
    }
  };

  return (
    <div className="app">
      <header className="header-bar">
        <h1 style={{ textAlign: 'right' }}>Welcome, {userName} {userRole && `(${userRole})`}{companyName && ` - ${companyName}`}</h1>
        <button onClick={handleLogout} className="logout-btn">Logout</button>
      </header>

      {userRole === 'SUPERADMIN' && (
        <main className="card">
          {/* COMPANIES */}
          <h2>Companies</h2>
          {companiesList.length ? companiesList.map(c =>
            <label key={c.company_id} style={{ display: 'block' }}>
              <input
                type="radio"
                name="company"
                checked={selectedManageCompanyId === c.company_id.toString()}
                onChange={() => handleSelectCompany(c.company_id)}
              />
              {c.name}
            </label>
          ) : <p>No companies</p>}

          <div style={{ display: 'flex', gap: '10px', marginTop: 20, marginBottom: '12px' }}>
            <button
              onClick={() => setShowAddCompanyForm(true)}
              style={{ width: '160px' }}
            >
              Create a company
            </button>
            <button
              onClick={() => {
                const cur = companiesList.find(c => c.company_id.toString() === selectedManageCompanyId);
                setModifyCompanyNameInput(cur.name);
                setShowModifyCompanyForm(true);
              }}
              disabled={!selectedManageCompanyId}
              style={{ width: '160px' }}
            >
              Modify company
            </button>
            <button
              onClick={handleDeleteCompany}
              disabled={!selectedManageCompanyId}
              style={{ width: '160px' }}
            >
              Delete company
            </button>
          </div>
          {deleteCompanyError && <span className="error-msg-inline">{deleteCompanyError}</span>}

          {showAddCompanyForm && (
            <form onSubmit={handleCreateCompany} className="user-form" style={{ marginTop: 10 }}>
              <input
                type="text"
                placeholder="Company name"
                value={createCompanyName}
                onChange={e => setCreateCompanyName(e.target.value)}
                required
                style={{ display: 'block', width: '80%', marginBottom: '12px' }}
              />
              <button type="submit" style={{ marginRight: '8px' }}>Save</button>
              <button type="button" onClick={() => { setShowAddCompanyForm(false); setCreateCompanyName(''); setCreateCompanyError(''); }}>
                Cancel
              </button>
              {createCompanyError && (
                <span className="error-msg-inline" style={{ display: 'block', marginTop: '8px' }}>
                  {createCompanyError}
                </span>
              )}
            </form>
          )}

          {showModifyCompanyForm && (
            <form onSubmit={handleModifyCompany} className="user-form" style={{ marginTop: 10 }}>
              <input
                placeholder="Company name"
                value={modifyCompanyNameInput}
                onChange={e => setModifyCompanyNameInput(e.target.value)}
                required
                style={{ display: 'block', width: '80%', marginBottom: '12px' }}
              />
              <button type="submit">Save</button><br></br><br></br>
              {modifyCompanyError && <span className="error-msg-inline">{modifyCompanyError}</span>}
            </form>
          )}
        </main>
      )}
      <br></br>

      <main className="card">
        {/* ADD USER */}
        {message && <h2>{message} registered users <span className="blinking-circle"></span></h2>}
        <br></br>
        <section>
          {!showAddUserForm ? (
            <button
              onClick={() => setShowAddUserForm(true)}
              style={{ marginBottom: '12px', width: '160px' }}
            >
              Create a user
            </button>
          ) : (
            <form onSubmit={handleCreateUser} className="user-form">
              {/* first name */}
              <div style={{ marginBottom: '12px' }}>
                <input
                  type="text"
                  placeholder="First Name"
                  value={newFirstName}
                  onChange={e => setNewFirstName(e.target.value)}
                  required
                  style={{ display: 'block', width: '80%' }}
                />
              </div>

              {/* last name */}
              <div style={{ marginBottom: '12px' }}>
                <input
                  type="text"
                  placeholder="Last Name"
                  value={newLastName}
                  onChange={e => setNewLastName(e.target.value)}
                  required
                  style={{ display: 'block', width: '80%' }}
                />
              </div>

              {/* email */}
              <div style={{ marginBottom: '12px' }}>
                <input
                  type="email"
                  placeholder="Email"
                  value={newEmail}
                  onChange={e => setNewEmail(e.target.value)}
                  required
                  style={{ display: 'block', width: '80%' }}
                />
              </div>

              {/* role */}
              <div style={{ marginBottom: '12px' }}>
                <label>
                  <select
                    value={newRole}
                    onChange={e => setNewRole(e.target.value)}
                    required
                    style={{ display: 'block', width: '80%', marginTop: '4px' }}
                  >
                    <option value="USER">User</option>
                    <option value="ADMIN">Admin (for SuperAdmin only)</option>
                  </select>
                </label>
              </div>

              {/* company (only relevant when creating an ADMIN) */}
              {newRole !== 'USER' && (
                <div style={{ marginBottom: '12px' }}>
                  {!useNewCompany ? (
                    <>
                      <select
                        value={selectedCompanyId}
                        onChange={e => setSelectedCompanyId(e.target.value)}
                        style={{ display: 'block', width: '80%', marginBottom: '8px' }}
                      >
                        <option value="">-- Select a company --</option>
                        {companiesList.map(c => (
                          <option key={c.company_id} value={c.company_id}>{c.name}</option>
                        ))}
                      </select>
                      <button type="button" onClick={() => { setUseNewCompany(true); setSelectedCompanyId(''); }}>
                        + New company
                      </button>
                    </>
                  ) : (
                    <>
                      <input
                        type="text"
                        placeholder="New company name"
                        value={newCompanyNameInput}
                        onChange={e => setNewCompanyNameInput(e.target.value)}
                        style={{ display: 'block', width: '80%', marginBottom: '8px' }}
                      />
                      <button type="button" onClick={() => { setUseNewCompany(false); setNewCompanyNameInput(''); }}>
                        Use an existing company
                      </button>
                    </>
                  )}
                </div>
              )}

              {/* phone */}
              <div style={{ marginBottom: '12px' }}>
                <input
                  type="text"
                  placeholder="Phone - +1 (263) 382-9329"
                  value={newPhone}
                  onChange={e => setNewPhone(e.target.value)}
                  required
                  style={{ display: 'block', width: '80%' }}
                />
              </div>

              {/* street */}
              <div style={{ marginBottom: '12px' }}>
                <input
                  type="text"
                  placeholder="Street"
                  value={newStreet}
                  onChange={e => setNewStreet(e.target.value)}
                  required
                  style={{ display: 'block', width: '80%' }}
                />
              </div>

              {/* postal code */}
              <div style={{ marginBottom: '12px' }}>
                <input
                  type="text"
                  placeholder="Postal Code"
                  value={newPostalCode}
                  onChange={e => setNewPostalCode(e.target.value)}
                  required
                  style={{ display: 'block', width: '80%' }}
                />
              </div>

              {/* city */}
              <div style={{ marginBottom: '12px' }}>
                <input
                  type="text"
                  placeholder="City"
                  value={newCity}
                  onChange={e => setNewCity(e.target.value)}
                  required
                  style={{ display: 'block', width: '80%' }}
                />
              </div>

              {/* country */}
              <div style={{ marginBottom: '12px' }}>
                <input
                  type="text"
                  placeholder="Country"
                  value={newCountry}
                  onChange={e => setNewCountry(e.target.value)}
                  required
                  style={{ display: 'block', width: '80%' }}
                />
              </div>

              {/* gateway */}
              <div style={{ marginBottom: '12px' }}>
                <input
                  type="text"
                  placeholder="Gateway"
                  value={newGateway}
                  onChange={e => setNewGateway(e.target.value)}
                  required
                  style={{ display: 'block', width: '80%' }}
                />
              </div>

              {/* gas type */}
              <select
                value={newGasType}
                onChange={e => setNewGasType(e.target.value)}
                required
                style={{ display:'block', width:'80%', marginBottom:'12px' }}
              >
                <option value="NATURAL">Natural</option>
                <option value="PROPANE">Propane</option>
              </select>

              {/* form actions */}
              <div style={{ marginTop: '12px' }}>
                <button
                  type="submit"
                  style={{ marginRight: '8px', marginBottom: '12px' }}
                >
                  Create User
                </button>
                <button
                  style={{ marginBottom: '12px' }}
                  type="button"
                  onClick={() => {
                  setShowAddUserForm(false);
                  setNewFirstName('');
                  setNewLastName('');
                  setNewEmail('');
                  setNewPhone('');
                  setNewStreet('');
                  setNewPostalCode('');
                  setNewCity('');
                  setNewCountry('');
                  setNewGateway('');
                  setCreationError('');
                }}
                >
                  Cancel
                </button>
              </div>

              {/* feedback */}
              {creationError && (
                <span className="error-msg-inline" style={{ display: 'block', marginTop: '8px' }}>
                  {creationError}
                </span>
              )}
            </form>
          )}
        </section>
      </main>
      <br></br>

      <main className="card">
        {/* SEARCH USER */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap', gap: '12px', marginBottom: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <h2 style={{ margin: 0 }}>All Users</h2>
          </div>
          {!searchResult && (
          <input
            type="text"
            placeholder="Filter by name, email or phone"
            value={userFilter}
            onChange={e => setUserFilter(e.target.value)}
            style={{ width: '100%', maxWidth: '300px', minWidth: '260px' }}
          /> )}
            <button style={{ width: '90px' }} onClick={() => window.location.reload()}>
              Refresh
            </button>
        </div>
        {searchError && <p className="error-msg-inline">{searchError}</p>}

        {!searchResult && (
        <section style={{ marginBottom: 40 }}>
        {listError && <p className="error-msg-inline">{listError}</p>}
        {filteredUsers.length === 0 ? (
          <p>No users found.</p>
        ) : (
          <table className="users-table">
            <thead>
              <tr>
                <th>ID</th><th>Name</th><th>Email</th><th>Phone</th><th>Role</th><th>Company</th><th>Joined</th><th>Search</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.map(u => (
                <tr key={u.user_id}>
                  <td>{u.user_id}</td>
                  <td>{u.first_name} {u.last_name}</td>
                  <td>{u.email} <FaCopy style={{ cursor: 'pointer' }} onClick={() => handleCopyEmail(u.email)} title="Copy email"/></td>
                  <td>{u.phone}</td>
                  <td>{u.role}</td>
                  <td>{u.company_name}</td>
                  <td>{new Date(u.created_at).toLocaleDateString()}</td>
                  <td>
                    <button type="button" onClick={() => handleSearch(u.email)}>
                      Select
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
      )}

        {searchResult && (
          <>
            {/* USER INFO */}
            <section style={{ marginTop: 20 }}>
              <h3>User Information</h3>
              <p><strong>ID:</strong> {searchResult.user_id}</p>
              <p><strong>Name:</strong> {searchResult.first_name} {searchResult.last_name}</p>
              <p><strong>Email:</strong> {searchResult.email}</p>
              <p><strong>Phone:</strong> {searchResult.phone}</p>
              <p><strong>Role:</strong> {searchResult.role}</p>
              <p><strong>Company:</strong> {searchResult.company_name}</p>
              <p><strong>Registered:</strong> {new Date(searchResult.created_at).toLocaleString()}</p>
              <p><strong>Address:</strong> {searchResult.street}, {searchResult.city}, {searchResult.country}, {searchResult.postal_code}</p>
              <p><strong>Gateway:</strong> {searchResult.gateway}</p>
            </section>

            {/* DELETE & UPDATE */}
            <section style={{ marginTop: 20 }}>
              <button onClick={handleDeleteUser}>Delete this user</button>

              {!showUpdateForm ? (
                <button onClick={() => setShowUpdateForm(true)} style={{ marginLeft: 10 }}>
                  Modify this user
                </button>
              ) : (
                <form onSubmit={handleUpdateUser} className="user-form" style={{ marginTop: 10 }}>
                  <input
                    type="text"
                    placeholder="First Name"
                    value={updateFirstName}
                    onChange={e => setUpdateFirstName(e.target.value)}
                    required
                    style={{ display: 'block', width: '80%', marginBottom: '12px' }}
                  />
                  <input
                    type="text"
                    placeholder="Last Name"
                    value={updateLastName}
                    onChange={e => setUpdateLastName(e.target.value)}
                    required
                    style={{ display: 'block', width: '80%', marginBottom: '12px' }}
                  />
                  <input
                    type="email"
                    placeholder="Email"
                    value={updateEmail}
                    onChange={e => setUpdateEmail(e.target.value)}
                    required
                    style={{ display: 'block', width: '80%', marginBottom: '12px' }}
                  />
                  <input
                    type="text"
                    placeholder="Phone"
                    value={updatePhone}
                    onChange={e => setUpdatePhone(e.target.value)}
                    required
                    style={{ display: 'block', width: '80%', marginBottom: '12px' }}
                  />
                  <button type="submit">Save</button><br></br><br></br>
                  {updateError && <span className="error-msg-inline">{updateError}</span>}
                </form>
              )}
              <br></br>
              {deleteError && <span className="error-msg-inline">{deleteError}</span>}
            </section>

            {/* HOUSES */}
            <section style={{ marginTop: 20 }}>
              <h3>Houses</h3>
              {addressOptions.length ? addressOptions.map(h =>
                <label key={h.house_id} style={{ display: 'block' }}>
                  <input
                    type="radio"
                    name="house"
                    checked={selectedHouse === h.house_id.toString()}
                    onChange={() => handleFetchRooms(h.house_id)}
                  />
                  {h.street}, {h.city}, {h.country}, <b>Gateway:</b> {h.gateway}, <b>Gas Level:</b>{' '}{h.gas_level != null ? `${h.gas_level}%` : 'undefined'}{' '} <b>Gas Type:</b> {h.gas_type}

                </label>
              ) : <p>No houses</p>}

              <button onClick={() => {setShowAddHouseForm(true); setSelectedHouse(''); }} style={{ marginTop: 20 }}>Add a house</button>
              {showAddHouseForm && (
                <form onSubmit={handleAddHouse} className="user-form" style={{ marginTop: 10, }}>
                  <input placeholder="Street" value={newStreet} onChange={e=>setNewStreet(e.target.value)} required style={{ display: 'block', width: '80%', marginBottom: '12px' }}/>
                  <input placeholder="Postal Code" value={newPostalCode} onChange={e=>setNewPostalCode(e.target.value)} required style={{ display: 'block', width: '80%', marginBottom: '12px' }}/>
                  <input placeholder="City" value={newCity} onChange={e=>setNewCity(e.target.value)} required style={{ display: 'block', width: '80%', marginBottom: '12px' }}/>
                  <input placeholder="Country" value={newCountry} onChange={e=>setNewCountry(e.target.value)} required style={{ display: 'block', width: '80%', marginBottom: '12px' }}/>
                  <input placeholder="Gateway" value={newGateway} onChange={e=>setNewGateway(e.target.value)} required style={{ display: 'block', width: '80%', marginBottom: '12px' }}/>
                  <select value={newGasType} onChange={e => setNewGasType(e.target.value)} required>
                    <option value="Natural">Natural</option>
                    <option value="Propane">Propane</option>
                  </select>
                  <br></br><br></br>
                  <button type="submit">Save</button><br></br><br></br>
                  {addHouseError && <span className="error-msg-inline">{addHouseError}</span>}
                </form>
              )}

              {selectedHouse && (
                  <>
                    <button
                      onClick={() => setShowTransferHouseForm(true)}
                      disabled={!selectedHouse}
                      style={{ marginLeft: 10, marginTop: 20 }}
                    >
                      Transfer ownership
                    </button>
                    {showTransferHouseForm && (
                      <form
                        onSubmit={handleTransferHouse}
                        className="user-form"
                        style={{ marginTop: 10 }}
                      >
                        <select
                          value={transferUserId}
                          onChange={e => setTransferUserId(e.target.value)}
                          required
                          style={{
                            display: 'block',
                            width: '80%',
                            marginBottom: '12px'
                          }}
                        >
                          <option value="">Select new owner</option>
                          {usersList
                            .filter(u => u.user_id !== searchResult.user_id)
                            .map(u => (
                              <option key={u.user_id} value={u.user_id}>
                                {u.first_name} {u.last_name} ({u.email})
                              </option>
                            ))
                          }
                        </select>
                        <button type="submit">Transfer</button>
                        {transferError && (
                          <span className="error-msg-inline" style={{ display: 'block' }}>
                            {transferError}
                          </span>
                        )}
                      </form>
                    )}
                  <button onClick={() => {
                    const cur = addressOptions.find(h=>h.house_id.toString()===selectedHouse);
                    setModifyStreetInput(cur.street);
                    setModifyPostalInput(cur.postal_code);
                    setModifyCityInput(cur.city);
                    setModifyCountryInput(cur.country);
                    setModifyGatewayInput(cur.gateway);
                    setModifyGasTypeInput(cur.gas_type);
                    setShowModifyHouseForm(true);
                  }} style={{ marginLeft: 10, marginTop: 20 }} disabled={!selectedHouse}>Modify house</button>
                  <button onClick={handleDeleteHouse} style={{ marginLeft: 10, marginTop: 20}} disabled={!selectedHouse}>Delete house</button>
                  <br></br>
                  {deleteHouseError && <span className="error-msg-inline">{deleteHouseError}</span>}

                  {showModifyHouseForm && (
                    <form onSubmit={handleModifyHouse} className="user-form" style={{ marginTop: 10 }}>
                      <input placeholder="Street" value={modifyStreetInput} onChange={e=>setModifyStreetInput(e.target.value)} required style={{ display: 'block', width: '80%', marginBottom: '12px' }}/>
                      <input placeholder="Postal Code" value={modifyPostalInput} onChange={e=>setModifyPostalInput(e.target.value)} required style={{ display: 'block', width: '80%', marginBottom: '12px' }}/>
                      <input placeholder="City" value={modifyCityInput} onChange={e=>setModifyCityInput(e.target.value)} required style={{ display: 'block', width: '80%', marginBottom: '12px' }}/>
                      <input placeholder="Country" value={modifyCountryInput} onChange={e=>setModifyCountryInput(e.target.value)} required style={{ display: 'block', width: '80%', marginBottom: '12px' }}/>
                      <input placeholder="Gateway" value={modifyGatewayInput} onChange={e=>setModifyGatewayInput(e.target.value)} required style={{ display: 'block', width: '80%', marginBottom: '12px' }}/>
                      <select value={modifyGasTypeInput} onChange={e => setModifyGasTypeInput(e.target.value)} required>
                        <option value="Natural">Natural</option>
                        <option value="Propane">Propane</option>
                      </select>
                      <br></br><br></br>
                      <button type="submit">Save</button><br></br><br></br>
                      {modifyHouseError && <span className="error-msg-inline">{modifyHouseError}</span>}
                    </form>
                  )}
                </>
              )}
            </section>

            {/* ROOMS */}
            {selectedHouse && (
              <section style={{ marginTop: 20 }}>
                <h3>Rooms</h3>
                {roomOptions.length ? roomOptions.map(r =>
                  <label key={r.room_id} style={{ display: 'block' }}>
                    <input
                      type="radio"
                      name="room"
                      checked={selectedRoom === r.room_id.toString()}
                      onChange={() => handleFetchSensors(r.room_id)}
                    />
                    {r.room_name}
                  </label>
                ) : <p>No rooms</p>}

                <button onClick={() => setShowAddRoomForm(true)} style={{ marginTop: 20 }}>Add a room</button>
                {showAddRoomForm && (
                  <form onSubmit={handleAddRoom} className="user-form" style={{ marginTop: 10 }}>
                    <input placeholder="Room Name" value={newRoomName} onChange={e=>setNewRoomName(e.target.value)} required style={{ display: 'block', width: '80%', marginBottom: '12px' }}/>
                    <button type="submit">Save</button><br></br><br></br>
                    {addRoomError && <span className="error-msg-inline">{addRoomError}</span>}
                  </form>
                )}

                {selectedRoom && (
                  <>
                    <button onClick={() => {
                      const cur = roomOptions.find(r=>r.room_id.toString()===selectedRoom);
                      setModifyRoomNameInput(cur.room_name);
                      setShowModifyRoomForm(true);
                    }} style={{ marginLeft: 10, marginTop: 20 }}>Modify room</button>
                    <button onClick={handleDeleteRoom} style={{ marginLeft: 10, marginTop: 20 }}>Delete room</button>
                    {deleteRoomError && <span className="error-msg-inline">{deleteRoomError}</span>}

                    {showModifyRoomForm && (
                      <form onSubmit={handleModifyRoom} className="user-form" style={{ marginTop: 10 }}>
                        <input placeholder="Room Name" value={modifyRoomNameInput} onChange={e=>setModifyRoomNameInput(e.target.value)} required style={{ display: 'block', width: '80%', marginBottom: '12px' }}/>
                        <button type="submit">Save</button><br></br><br></br>
                        {modifyRoomError && <span className="error-msg-inline">{modifyRoomError}</span>}
                      </form>
                    )}
                  </>
                )}
              </section>
            )}

            {/* SENSORS */}
            {selectedRoom && (
              <section style={{ marginTop: 20 }}>
                <h3>Sensors</h3>
                {sensorDataError && <p className="error-msg-inline">{sensorDataError}</p>}
                {sensorData.length ? (
                  <table style={{ width:'100%', borderCollapse: 'collapse', border: '1px solid', textAlign: 'center' }}>
                    <thead>
                      <tr style={{ border: '1px solid' }}>
                        <th>Select</th><th>Serial Number</th><th>Device Type</th><th>Reading Type</th><th>Value</th><th>Last Update</th><th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sensorData.map(s => (
                        <tr key={s.serial_number}>
                          <td>
                            <input
                              type="radio"
                              checked={selectedSensorSerial === s.serial_number}
                              onChange={() => {
                                setSelectedSensorSerial(s.serial_number);
                                setShowModifySensorForm(false);
                                setDeleteSensorError('');
                              }}
                            />
                          </td>
                          <td>{s.serial_number}</td>
                          <td>{s.device_type === 'General' ? 'Gas Sensor' : s.device_type}</td>
                          <td>{s.reading_type}</td>
                          <td>{s.value}</td>
                          <td>{s.timestamp ? new Date(s.timestamp).toLocaleString() : 'N/A'}</td>
                          <td>
                            {isSensorActive(s.timestamp) ? (
                              <span style={{ color: 'green', fontWeight: 'bold' }}>● Active</span>
                            ) : (
                              <span style={{ color: 'red', fontWeight: 'bold' }}>● Inactive</span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : <p>No sensors</p>}

                <button onClick={handleDeleteSensor} disabled={!selectedSensorSerial} style={{ marginTop: 20 }}>
                  Delete sensor
                </button>
                {deleteSensorError && <span className="error-msg-inline">{deleteSensorError}</span>}

                <button onClick={() => {
                  const cur = sensorData.find(s=>s.serial_number===selectedSensorSerial);
                  setModifySensorSerialNumberInput(cur?.serial_number||'');
                  setShowModifySensorForm(true);
                }} disabled={!selectedSensorSerial} style={{ marginLeft: 10, marginTop: 20 }}>
                  Modify sensor
                </button>

                {showModifySensorForm && (
                  <form onSubmit={handleModifySensor} className="user-form" style={{ marginTop: 10 }}>
                    <input
                      placeholder="Serial Number"
                      value={modifySensorSerialNumberInput}
                      onChange={e=>setModifySensorSerialNumberInput(e.target.value)}
                      required
                      style={{ display: 'block', width: '80%', marginBottom: '12px' }}
                    />
                    <button type="submit">Save</button><br></br><br></br>
                    {modifySensorError && <span className="error-msg-inline">{modifySensorError}</span>}
                  </form>
                )}

                <button onClick={() => setShowAddSensorForm(true)} style={{ marginTop: 10, marginLeft: 10 }}>
                  Add a sensor
                </button>
                {showAddSensorForm && (
                  <form onSubmit={handleAddSensor} className="user-form" style={{ marginTop: 10 }}>
                    <input
                      placeholder="Serial Number"
                      value={sensorSerialNumber}
                      onChange={e=>setSensorSerialNumber(e.target.value)}
                      required
                      style={{ display: 'block', width: '80%', marginBottom: '12px' }}
                    />
                    <select
                      value={deviceTypeInput}
                      onChange={e=>setdeviceTypeInput(e.target.value)}
                      required
                      style={{ display: 'block', width: '80%', marginBottom: '12px' }}
                    >
                      <option value="">--Type--</option>
                      <option>General</option>
                      <option>Gas Level</option>
                    </select>
                    <button type="submit">Save</button><br></br><br></br>
                    {addSensorError && <span className="error-msg-inline">{addSensorError}</span>}
                  </form>
                )}
              </section>
            )}
          </>
        )}
      </main>
    </div>
  );
}
